// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tBJ2","title":"Info_title__34hL-","links":"Info_links__38ePM","link":"Info_link__29Tds","logo":"Info_logo__29C7H"};